import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ACTIONS = [
  {
    to: '/property-search-browse',
    title: 'Find a property',
    description: 'Search rentals, sales, and land across Uganda',
    icon: 'Search',
    accent: 'bg-sky-50 text-sky-700 border-sky-100',
  },
  {
    to: '/saved-properties',
    title: 'Saved properties',
    description: 'Review homes you have shortlisted',
    icon: 'Heart',
    accent: 'bg-rose-50 text-rose-700 border-rose-100',
  },
  {
    to: '/notice-board',
    title: 'Notice Board',
    description: 'Post requests & review agent matches',
    icon: 'ClipboardList',
    accent: 'bg-violet-50 text-violet-700 border-violet-100',
  },
  {
    to: '/workspace/bookings',
    title: 'Book an advisor',
    description: 'Schedule a consultation with a verified pro',
    icon: 'Calendar',
    accent: 'bg-amber-50 text-amber-800 border-amber-100',
  },
  {
    to: '/user-dashboard/profile',
    title: 'My profile',
    description: 'Update contact details and preferences',
    icon: 'User',
    accent: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  },
  {
    to: '/hostels',
    title: 'Student hostels',
    description: 'Browse university accommodation options',
    icon: 'Building',
    accent: 'bg-cyan-50 text-cyan-800 border-cyan-100',
  },
];

const QuickActions = () => (
  <section>
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-base font-semibold text-slate-900">Quick actions</h2>
    </div>
    <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
      {ACTIONS.map((action) => (
        <Link
          key={action.to}
          to={action.to}
          className="group rounded-xl border border-slate-200 bg-white p-4 hover:border-slate-300 hover:shadow-md transition-all"
        >
          <div
            className={`w-10 h-10 rounded-lg border flex items-center justify-center mb-3 ${action.accent}`}
          >
            <Icon name={action.icon} size={18} />
          </div>
          <p className="font-semibold text-slate-900 group-hover:text-slate-700">{action.title}</p>
          <p className="text-xs text-slate-500 mt-1 leading-relaxed">{action.description}</p>
        </Link>
      ))}
    </div>
  </section>
);

export default QuickActions;
